import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_404: DocMigration = {
  maxSchemaVersion: "0.0.404",
  description: "Add skylights sheet geometry category",
  apply(json: any) {
    if (!json.viewTemplates) {
      return json;
    }

    for (const id in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[id];

      const isPlan = viewTemplate.viewType === "PLAN_VIEW";
      const addSkylights =
        (isPlan && viewTemplate.categories.indexOf("ROOF") >= 0) ||
        (!isPlan && viewTemplate.categories.indexOf("WINDOWS") >= 0);
      if (addSkylights) {
        viewTemplate.categories.push("SKYLIGHTS");
      }
    }

    return json;
  },
};

export default migration_0_0_404;
